// Contact.jsx
import React from 'react';
import ContactCard from '../components/ContactCard';
import '../styles/Contact.css';

function Contact() {
  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>Get In Touch</h1>
        <p className="subtitle">Our team is here to help you with any questions you may have</p>
      </div>
      <div className="contact-list">
        <ContactCard 
          name="Marek-Jerzy Pindera, PhD" 
          title="Senior Researcher"
          email="emc_llc@comcast.net"
          phone="(434) 974-6536"
          imageSrc="/assets/Pindera.png"
          address="1252 Chatham Ridge Drive, Charlottesville, VA 22901"
        />
        <ContactCard 
          name="Heze Chen, PhD" 
          title="Assistant Professor of Applied Mathematics at UVA"
          email="hc9xc@virginia.edu"
          phone="(434) 924-4912"
          imageSrc="/assets/Heze.jpg"
          address="Albert H. Small Building, 156 Engineer's Way, Charlottesville, VA 22903"
        />
      </div>
    </div>
  );
}

export default Contact;